import { i as e } from "./errors-BJxlOkXf.js";
import { n as t, r as n, t as r } from "./processInitiationViewContext-CRN1YTzW.js";
//#region src/shell/formSessionValidation.ts
function i(e) {
	return typeof e == "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e);
}
function a(e, t) {
	return e.runtimeEpoch === t.runtimeEpoch && e.formKey === t.formKey && e.generation === t.generation && e.sessionId === t.sessionId;
}
function o(t) {
	let n = m(f(t));
	if (!h(n, [
		"runtimeEpoch",
		"formKey",
		"generation",
		"sessionId"
	]) || !i(n.runtimeEpoch) || typeof n.formKey != "string" || !v(n.generation) || n.sessionId !== JSON.stringify([
		n.runtimeEpoch,
		n.formKey,
		n.generation
	])) throw e("INPUT_INVALID");
	return Object.freeze({
		runtimeEpoch: n.runtimeEpoch,
		formKey: n.formKey,
		generation: n.generation,
		sessionId: n.sessionId
	});
}
function s(e, t) {
	let n = t.contextType === "WORK_ITEM" ? t.workflowTaskPublicId : t.contextType === "DRAFT" ? t.draftContext.draftPublicId : t.processInstancePublicId;
	return JSON.stringify([
		e,
		t.applicationCode,
		t.contextType,
		n
	]);
}
function c(i, a, c) {
	try {
		let u = m(f(i));
		if (!h(u, [
			"token",
			"revision",
			"tenantPublicId",
			"pageRoute",
			"context"
		]) || !v(u.revision) || u.tenantPublicId !== a.tenantPublicId || !t(u.pageRoute) || a.basePath && a.basePath !== "/" && (u.pageRoute === a.basePath || u.pageRoute.startsWith(`${a.basePath}/`))) throw e("INPUT_INVALID");
		let d = o(u.token), p = m(u.context), g = p.contextType === "WORK_ITEM" ? n(p, a.applicationCode) : p.contextType === "PROCESS_INITIATION_VIEW" ? r(p, a.applicationCode) : l(p, a.applicationCode, a.actorPublicId);
		if (d.runtimeEpoch !== c || d.formKey !== s(a.tenantPublicId, g) || g.contextType === "DRAFT" && g.pageRoute !== u.pageRoute) throw e("INPUT_INVALID");
		return f({
			token: d,
			revision: u.revision,
			tenantPublicId: a.tenantPublicId,
			pageRoute: u.pageRoute,
			context: g
		});
	} catch (t) {
		throw e("INPUT_INVALID", t);
	}
}
function l(n, r, a) {
	let o = m(f(n)), s = m(o.draftContext);
	if (!h(o, [
		"contextType",
		"applicationCode",
		"processId",
		"businessTaskId",
		"businessObjectType",
		"businessObjectPublicId",
		"pageRoute",
		"availableActions",
		"workItemContext",
		"draftContext"
	]) || o.contextType !== "DRAFT" || o.applicationCode !== r || !g(o.processId, 128) || !g(o.businessTaskId, 128) || !g(o.businessObjectType, 100) || !g(o.businessObjectPublicId, 128) || !t(o.pageRoute) || o.workItemContext !== null || !h(s, [
		"draftPublicId",
		"expectedDraftVersion",
		"ownerPublicId",
		"lastSavedAt",
		"expiresAt",
		"draftStatus",
		"projectionHealth"
	]) || !i(s.draftPublicId) || !v(s.expectedDraftVersion) || s.ownerPublicId !== a || !_(s.lastSavedAt) || !_(s.expiresAt) || !g(s.draftStatus, 64) || !g(s.projectionHealth, 64) || !Array.isArray(o.availableActions) || o.availableActions.length > 16) throw e("INPUT_INVALID");
	let c = /* @__PURE__ */ new Set();
	for (let t of o.availableActions) {
		let n = m(t);
		if (!h(n, [
			"actionCode",
			"label",
			"emphasis",
			"requiresComment",
			"operationType"
		]) || !g(n.actionCode, 160) || !/^[A-Z][A-Z0-9_]*$/.test(n.actionCode) || c.has(n.actionCode) || !g(n.label, 200) || ![
			"default",
			"primary",
			"danger"
		].includes(String(n.emphasis)) || typeof n.requiresComment != "boolean" || ![
			"SHELL_LOCAL",
			"WORKFLOW",
			"DRAFT_WORKFLOW"
		].includes(String(n.operationType))) throw e("INPUT_INVALID");
		c.add(n.actionCode);
	}
	return f(o);
}
function u(t) {
	if (!t) throw e("HOST_UNAVAILABLE");
	let n = m(t);
	if (n.protocolVersion !== 1) throw e("PROTOCOL_UNSUPPORTED");
	if (!i(n.runtimeEpoch) || typeof n.registerReceiver != "function") throw e("CAPABILITY_INVALID");
	return Object.freeze({
		protocolVersion: 1,
		runtimeEpoch: n.runtimeEpoch,
		registerReceiver: n.registerReceiver
	});
}
function d(t) {
	let n = m(t);
	if (n.protocolVersion !== 1) throw e("PROTOCOL_UNSUPPORTED");
	if ([
		"activate",
		"deactivate",
		"update"
	].some((e) => typeof n[e] != "function")) throw e("CAPABILITY_INVALID");
	return t;
}
function f(t, n = /* @__PURE__ */ new Set()) {
	if (t === null || typeof t == "string" || typeof t == "boolean" || typeof t == "number" && Number.isFinite(t)) return t;
	if (typeof t != "object" || !t || n.has(t)) throw e("INPUT_INVALID");
	let r = Array.isArray(t), i = Object.getPrototypeOf(t);
	if (r ? !p(i, Array) : i !== null && !p(i, Object)) throw e("INPUT_INVALID");
	let a = Object.getOwnPropertyDescriptors(t), o = Reflect.ownKeys(a);
	if (o.some((e) => typeof e != "string") || r && (!Object.hasOwn(a.length, "value") || !Number.isSafeInteger(a.length.value) || a.length.value < 0 || o.length !== a.length.value + 1)) throw e("INPUT_INVALID");
	n.add(t);
	try {
		let t = r ? [] : {};
		for (let i of o) {
			if (r && i === "length") continue;
			let o = a[i];
			if (!Object.hasOwn(o, "value") || !o.enumerable || r && (!/^(0|[1-9][0-9]*)$/.test(i) || Number(i) >= a.length.value)) throw e("INPUT_INVALID");
			Object.defineProperty(t, i, {
				value: f(o.value, n),
				enumerable: !0,
				writable: !0,
				configurable: !0
			});
		}
		return Object.freeze(t);
	} finally {
		n.delete(t);
	}
}
function p(e, t) {
	if (!e) return !1;
	let n = Object.getOwnPropertyDescriptor(e, "constructor");
	if (!n || !Object.hasOwn(n, "value") || typeof n.value != "function" || Function.prototype.toString.call(n.value) !== Function.prototype.toString.call(t) || Object.getOwnPropertyDescriptor(n.value, "prototype")?.value !== e) return !1;
	let r = Object.getPrototypeOf(e);
	return t === Object ? r === null : p(r, Object);
}
function m(e) {
	return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function h(e, t) {
	return Object.keys(e).length === t.length && t.every((t) => Object.hasOwn(e, t));
}
function g(e, t) {
	return typeof e == "string" && e.length > 0 && e.length <= t && e === e.trim() && !/[\r\n]/.test(e);
}
function _(e) {
	return g(e, 64) && /(?:Z|[+-]\d{2}:\d{2})$/.test(e) && Number.isFinite(Date.parse(e));
}
function v(e) {
	return Number.isSafeInteger(e) && Number(e) > 0;
}
//#endregion
export { l as a, c, a as i, o as l, f as n, u as o, i as r, d as s, s as t };
